import React, { useEffect, useState } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { apiFetch } from "../../../../apiBindings";
import Columns from "../../Columns";
import LinkComponent from "../../LinkComponent";
import LoadingIndicator from "../../LoadingIndicator";
import Button from "../../NewForms/Button";
import HeadlineItem from "../ContentElement/HeadlineItem";

const Container = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.left}
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerInner.top}
        ${theme.paddings.containerInner.bottom}

        color: ${theme.colors.blue.toString()}
    `}
`;

const RestaurantName = styled.div`
    font-weight: 700;
`;

const RestaurantAddress = styled.div`
    margin-bottom: 10px;
`;

const buttonStyles = css`
    margin-top: 20;
`;

const GasStationsLunchOffers = ({ headlineNumber, text }) => {
    const initialNumberRestaurants = 12;
    const [restaurants, setRestaurants] = useState([]);
    const [collapsed, setCollapsed] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        apiFetch("/gas-stations/restaurants")
            .then((response) => response.json())
            .then((response) => {
                setLoading(false);
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                setRestaurants(response ?? []);
                if (response.length > 12) {
                    setCollapsed(true);
                }
            });
    }, []);

    return (
        <Container>
            <HeadlineItem headline={headlineNumber}>{text}</HeadlineItem>
            {loading ? (
                <LoadingIndicator />
            ) : (
                <>
                    {restaurants.length > 0 && (
                        <Columns>
                            {restaurants.map((restaurant, index) => {
                                if (
                                    collapsed &&
                                    index >= initialNumberRestaurants
                                ) {
                                    return null;
                                }
                                return (
                                    <Columns.Column
                                        mobile="full"
                                        tablet="half"
                                        fullhd="one-third"
                                        key={index}
                                    >
                                        <RestaurantName>
                                            {restaurant.name}
                                        </RestaurantName>
                                        <RestaurantAddress>
                                            {restaurant.address.streetAddress}
                                            <br />
                                            {restaurant.address.postalCode}{" "}
                                            {restaurant.address.locality}
                                        </RestaurantAddress>
                                        <LinkComponent
                                            icon="arrow-right"
                                            link={{
                                                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                                                href: `/tankstelle/${restaurant.url}`,
                                                text: "Zur Tageskarte",
                                            }}
                                        />
                                    </Columns.Column>
                                );
                            })}
                        </Columns>
                    )}
                    {restaurants.length < 1 && (
                        <p>Es wurden keine Mittagsangebote gefunden.</p>
                    )}

                    {restaurants.length > initialNumberRestaurants &&
                        collapsed && (
                            <Button
                                css={buttonStyles}
                                color="redOutline"
                                onClick={() => {
                                    setCollapsed(false);
                                }}
                                centered
                            >
                                Alle anzeigen
                            </Button>
                        )}
                </>
            )}
        </Container>
    );
};

export default GasStationsLunchOffers;
